import Cookies from 'js-cookie';
import psl, { ParsedDomain, ParseError } from 'psl';

import { JWT_TOKEN_COOKIE_KEY, REFRESH_TOKEN_COOKIE_KEY, EXPIRES_IN_COOKIE_KEY } from '../constants';

export const getDomain = () => {
  let domain = 'localhost';
  const isParsedDomain = (arg: psl.ParsedDomain | psl.ParseError): arg is ParsedDomain => {
    return Object.hasOwn(arg, 'domain');
  };

  if (window.location.hostname !== 'localhost') {
    const pslUrl: ParsedDomain | ParseError = psl.parse(window.location.hostname);
    if (isParsedDomain(pslUrl)) domain = pslUrl.domain || domain;
  }

  return domain;
};

export const getCookieOptions = () => {
  return {
    expires: 1, // durata di 1 giorno, se non viene messa la durata diventa un session cookie che viene eliminato dopo aver chiuso il browser
    domain: getDomain(),
  };
};

export const getBackUrl = (): string => {
  const backToURL = new URL(window.location.href);
  const params = new URLSearchParams(backToURL.search);
  let backTo = `${window.location.origin}${window.location.pathname}?${params}`;
  backTo = backTo.replace('/login?', '');
  return backTo.endsWith('?') ? backTo.replace('?', '') : backTo;
};

export const setTokenCookies = (token: IToken) => {
  const cookieOptions = getCookieOptions();

  Cookies.set(JWT_TOKEN_COOKIE_KEY, token.accessToken, cookieOptions);
  Cookies.set(REFRESH_TOKEN_COOKIE_KEY, token.refreshToken, cookieOptions);
  Cookies.set(EXPIRES_IN_COOKIE_KEY, token.expiresIn, cookieOptions);
};
